
export class TournamentConfigVO {
    public tabletype: number = 0;
    public sort: number = 0;
    public up: number = 0;
    public down: number = 0;
    public input: number = 0;
}
